export default __webpack_public_path__ + "static/background-efcd2a56e1af114eeea50e107bc4d2e3.jpg";